const logoImage = "/images/ReliefHub-logo-color.png"
const sidebarDashboardIcon = "/images/sidebar-icons/home-icon.png"
const sidebarWorkOrderIcon = "/images/sidebar-icons/work-orders-icon.png"
const sidebarReportIcon = "/images/sidebar-icons/reports-icon.png"
const sidebarMemberIcon = "/images/sidebar-icons/members-icon.png"
const sidebarMessageIcon = "/images/sidebar-icons/message-icon.png"
const sidebarSettingIcon = "/images/sidebar-icons/settings-icon.png"
const sidebarPlanningIcon = "/images/sidebar-icons/home-owners-icon.png"
const sidebarWorkScopeIcon = "/images/sidebar-icons/work-scope-icon.png"
const sidebarProfileIcon = "/images/sidebar-icons/mission.png"
const sidebarPartnersIcon = "/images/sidebar-icons/handshake-icon.png"
const sidebarToolsSuppliesIcon = "/images/sidebar-icons/tool-box-icon.png"
const sidebarPriorityIcon = "/images/sidebar-icons/work-scope-icon.png"
const threeDotsIcon = "/images/sidebar-icons/three-vertical-dots.png"
const userImage = "/images/demo-user.png"
const userImage2 = "/images/demo-user-2.png"
const deleteIconPng = "/images/delete-icon.png"
const googleIcon = "/images/google-icon.png"
const chevronUp = "/images/chevron-up.svg"
// home owners
const homeWarningIcon = "/images/home-owners/home-warning.svg"
const homeShieldIcon = "/images/home-owners/home-shield.svg"
const homeRemoveIcon = "/images/home-owners/home-remove.svg"
const buttonIcon = "/images/home-owners/button.svg"
const navigationMap = "/images/home-owners/navigation-map.svg"
// auth
const mapIcon = "/images/auth/map.svg"

export {
    logoImage,

    // Sidebar Icons
    sidebarDashboardIcon,
    sidebarWorkOrderIcon,
    sidebarReportIcon,
    sidebarMemberIcon,
    sidebarMessageIcon,
    sidebarSettingIcon,
    sidebarPlanningIcon,
    sidebarWorkScopeIcon,
    sidebarProfileIcon,
    sidebarPartnersIcon,
    sidebarToolsSuppliesIcon,
    sidebarPriorityIcon,
    userImage,
    userImage2,
    deleteIconPng,
    threeDotsIcon,
    googleIcon,
    chevronUp,

    // home owners
    homeWarningIcon,
    homeShieldIcon,
    homeRemoveIcon,
    buttonIcon,
    navigationMap,

    // auth
    mapIcon,
}
